import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["card"]

  connect() {
    this.dragSrcEl = null
  }

  dragstart(event) {
    this.dragSrcEl = event.currentTarget
    event.currentTarget.classList.add("dragging")
    event.dataTransfer.effectAllowed = "move"
    event.dataTransfer.setData("text/plain", event.currentTarget.dataset.geographyId)
  }

  dragover(event) {
    event.preventDefault()
    event.dataTransfer.dropEffect = "move"

    const card = event.currentTarget
    if (card === this.dragSrcEl) return

    const rect = card.getBoundingClientRect()
    const midX = rect.left + rect.width / 2
    const isAfter = event.clientX > midX

    // Clear all indicators first
    this.cardTargets.forEach(c => {
      c.classList.remove("drop-before", "drop-after")
    })

    card.classList.add(isAfter ? "drop-after" : "drop-before")
  }

  dragleave(event) {
    event.currentTarget.classList.remove("drop-before", "drop-after")
  }

  drop(event) {
    event.preventDefault()
    const target = event.currentTarget
    if (target === this.dragSrcEl) return

    const rect = target.getBoundingClientRect()
    const midX = rect.left + rect.width / 2
    const isAfter = event.clientX > midX

    // Reorder DOM elements
    if (isAfter) {
      target.parentNode.insertBefore(this.dragSrcEl, target.nextSibling)
    } else {
      target.parentNode.insertBefore(this.dragSrcEl, target)
    }

    this.clearDragState()
    this.persistOrder()
  }

  dragend() {
    this.clearDragState()
  }

  clearDragState() {
    this.cardTargets.forEach(c => {
      c.classList.remove("dragging", "drop-before", "drop-after")
    })
    this.dragSrcEl = null
  }

  persistOrder() {
    const newIds = this.cardTargets.map(c => c.dataset.geographyId)
    const params = new URLSearchParams(window.location.search)
    const period = params.get("period")

    const newParams = new URLSearchParams()
    newIds.forEach(id => newParams.append("geography_ids[]", id))
    if (period) newParams.set("period", period)

    const url = `/dashboard?${newParams.toString()}`
    history.replaceState(null, "", url)
  }
}
